import React, { useContext, useState } from "react";
import FileList from "../fileList/fileList";
import ClientTable from "../clientTable/clientTable";
import { Button } from "react-bootstrap";
import RejectionHistoryTable from "../rejectionHistoryTable/rejectionHistoryTable";
import SuccessModal from "../modals/successModal/successModal";
import RejectModal from "../modals/rejectModal/rejectModal";
import ReportsService from "../../../../../../services/reports-service";
import { IdentityContext } from "../../../../../../context/identity-context";

const ReportDetails = ({ report }) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  
  const { user } = useContext(IdentityContext);
  const reportService = new ReportsService();
  const checkerName = user.attributes['custom:display_name'];

  const handleSendReport = async () => {
    try {
      await reportService.adcuCheckerSubmitReport(
        report.reportHash,
        report.interestPaymentDate,
        checkerName
      );
      setShowSuccessModal(true); // Show success modal if API call succeeds
    } catch (error) {
      console.error("Error sending report:", error);
    }
  };

  const handleRejectReport = () => {
    setShowRejectModal(true);
  };

  const isDisabled = report.status !== "For Checking";

  return (
    <>
      <FileList files={report.files} report={report} />
      <ClientTable clients={report.clients} />
      <RejectionHistoryTable rejectionHistory={report.rejectionHistory} />
      <div className="d-flex justify-content-end">
        <Button variant="danger" className="me-2" onClick={handleRejectReport} disabled={isDisabled}>
          Reject
        </Button>
        <Button variant="primary" className="mx-2" onClick={handleSendReport} disabled={isDisabled}>
          Send Report
        </Button>
      </div>
      <SuccessModal show={showSuccessModal} handleClose={() => setShowSuccessModal(false)} report={report} />
      <RejectModal show={showRejectModal} handleClose={() => setShowRejectModal(false)} report={report} />
    </>
  );
};

export default ReportDetails;
